import { sellerRouteFactory } from './index';

/** @module */
export default sellerRouteFactory('/postings/search/');
